import React from 'react';
import { Center, Stack, Text, Loader } from '@mantine/core';
import theme from 'theme';
import useLang from 'lang';
import SimpleLayout from 'layouts/SimpleLayout';

interface LoadingStateProps {
  message?: string;
  subMessage?: string;
}

/**
 * Loading state component for displaying loading indicators
 */
const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading request details...',
  subMessage = 'Please wait while we fetch the information',
}) => {
  const { _t } = useLang();

  return (
    <SimpleLayout>
      <Center h="60vh">
        <Stack align="center" gap="lg">
          <Loader size="xl" color={theme.colors?.primary?.[0]} />
          <Text size="lg" color={theme.colors?.gray?.[10]} fw={500}>
            {_t(message)}
          </Text>
          <Text size="sm" color={theme.colors?.gray?.[8]} ta="center">
            {_t(subMessage)}
          </Text>
        </Stack>
      </Center>
    </SimpleLayout>
  );
};

export default LoadingState;
